import logger from '@tcp/core/src/utils/loggerInstance';
import {
  getImageForSEO,
  isSameCategory,
  getImageForSEOFromCarousalData,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.utils';
import { deriveSEOTags } from '@tcp/core/src/config/SEOTags.config';
import { getLocalStorage } from '@tcp/core/src/utils/utils.web';
/**
 *
 * @param {*} navTree
 * @param {*} pathName
 * checks for L2 ctegories, if L2 categories are present then move them out of the groups into a single array of L2 categories
 * Out of single array filters out category haviing '-outfit' seotoken
 * This selected category is passed to out this function. If this selected category has further L3 then those are passed out as categoryIds
 * @returns a list of categoryIDs
 */
export const getcategoryID = (navTree, pathName) => {
  let list = [];
  const categoryList = [];
  const categoryNameList = {};

  if (navTree?.hasL2 > 0) {
    Object.keys(navTree?.subCategories).forEach((group) => {
      list = list.concat(navTree?.subCategories[group]?.items);
    });
    const selectedCat = list?.filter((item) => pathName.includes(item?.categoryContent?.seoToken));
    if (selectedCat?.length > 0) {
      if (selectedCat[0]?.hasL3 === 0) {
        categoryList.push(selectedCat[0]?.categoryContent?.seoToken);
        categoryNameList[selectedCat[0]?.categoryContent?.seoToken] =
          selectedCat[0]?.categoryContent?.name;
      } else {
        selectedCat[0]?.subCategories?.forEach((item) => {
          categoryList.push(item?.categoryContent?.seoToken);
          categoryNameList[item?.categoryContent?.seoToken] = item?.categoryContent?.name;
        });
      }
    }
  }
  return [categoryList, categoryNameList];
};

export const getSeoTagConfig = ({
  pageId,
  paginatedProducts,
  seoTitle,
  seoMetaDesc,
  canonicalUrl,
  router,
  genericCarouselData,
  isPLPCarouselEnabled,
  isNewSEOHreflangLinkEnabled,
  seoTokenList,
}) => {
  if (pageId && paginatedProducts) {
    let imageURL = null;
    try {
      const { carouselData } = genericCarouselData;
      if (isPLPCarouselEnabled && Array.isArray(carouselData) && carouselData.length > 0) {
        imageURL = getImageForSEOFromCarousalData(carouselData, router?.query?.cid);
      }
      if (!imageURL) {
        imageURL = getImageForSEO(paginatedProducts);
      }
    } catch (ex) {
      logger.error({
        error: `Error while extracting PLP image for og tag - ${ex}`,
        extraData: {
          componentName: `category listing  Container`,
          method: `getSEOTags`,
          paginatedProducts,
        },
      });
    }
    const seoConfig = deriveSEOTags(
      pageId,
      { seoTitle, seoMetaDesc, canonicalUrl },
      router,
      imageURL,
      isNewSEOHreflangLinkEnabled,
      seoTokenList
    );
    if (seoConfig && seoConfig.title) {
      return {
        seoConfig,
      };
    }
  }
  return { seoConfig: null };
};

export const shouldRenderBlank = (asPath, processedBreadCrumbs, isFacetedNavigationEnabled) => {
  const prevUrl = getLocalStorage('previousUrl') || '';
  const isPreviousPageNotPlpPage = !prevUrl.includes('/c/');
  const isAsPathSameAsBreadCrumb = isSameCategory(
    asPath,
    processedBreadCrumbs,
    isFacetedNavigationEnabled
  );
  return !isAsPathSameAsBreadCrumb && isPreviousPageNotPlpPage;
};

export const shouldRenderSkeleton = (asPath, processedBreadCrumbs) => {
  const prevUrl = getLocalStorage('previousUrl') || '';
  const isPreviousPagePlpPage = prevUrl?.includes('/c/');
  const isAsPathSameAsBreadCrumb = isSameCategory(asPath, processedBreadCrumbs);
  return !isAsPathSameAsBreadCrumb && isPreviousPagePlpPage;
};

export const shouldRenderSkeletonNew = (
  asPath,
  processedBreadCrumbs,
  isFacetedNavigationEnabled
) => {
  const prevUrl = getLocalStorage('previousUrl') || '';
  const isPreviousPagePlpPage = prevUrl?.includes('/c/');
  const isAsPathSameAsBreadCrumb = isSameCategory(
    asPath,
    processedBreadCrumbs,
    isFacetedNavigationEnabled
  );
  return !isAsPathSameAsBreadCrumb && isPreviousPagePlpPage;
};

export const replaceWord = (string, pattern, replacement) => {
  const regex = new RegExp(pattern, 'g');
  return string?.replace(regex, replacement);
};

export const removePatternsFromSeoTitle = (seoTitle) => {
  let updatedSeoTitle = seoTitle;

  const patternsToRemove = [
    '<color> ',
    '<c_color> ',
    '<size> ',
    '<s_size> ',
    '<s_size>',
    '<h1>',
    '</h1>',
  ];

  patternsToRemove.forEach((pattern) => {
    updatedSeoTitle = replaceWord(updatedSeoTitle, pattern, '');
  });

  return updatedSeoTitle;
};

export const getCurrentPageNumber = (pageNumber) => {
  return parseInt(pageNumber || 1, 10);
};

const extractSegment = (url) => {
  // Find the index of '/c/'
  const startIndex = url.indexOf('/c/') + 3;

  if (startIndex === 2) {
    // +3 -1 if '/c/' is not found, index will be 2
    return null; // '/c/' not found in the URL
  }

  // Find the index of the next '/' after '/c/'
  let endIndex = url.indexOf('/', startIndex);

  // If no '/' is found, find the index of the next '?'
  if (endIndex === -1) {
    endIndex = url.indexOf('?', startIndex);
  }

  // If no '?' is found, take the rest of the string
  if (endIndex === -1) {
    endIndex = url.length;
  }

  // Extract the substring from startIndex to endIndex
  return url.substring(startIndex, endIndex);
};

const checkIfColorSizeFilterPresent = ({ appliedFilters, pathName }) => {
  if (!appliedFilters || !pathName) {
    return false;
  }

  const segment = extractSegment(pathName);
  if (!segment) {
    return false;
  }

  const isCollectionOrGymmies = segment.includes('collection') || segment.includes('gymmies');
  const hasColorFilter = appliedFilters?.TCPColor_uFilter?.length > 0;
  const hasSizeFilter =
    appliedFilters?.v_clothingsize_uFilter?.length > 0 ||
    appliedFilters?.v_clothingsizefacet_uFilter?.length > 0;
  return isCollectionOrGymmies && (hasColorFilter || hasSizeFilter);
};

export const isFacetedNavigationNoIndexApplicable = ({
  isPLPFacetedNavigationEnabled,
  filterCount,
  appliedFilters,
  pathName,
}) => {
  return (
    isPLPFacetedNavigationEnabled &&
    (filterCount > 1 || checkIfColorSizeFilterPresent({ appliedFilters, pathName }))
  );
};
